import React from 'react';
import { EntityForm } from '../../widgets/Forms';
import { CustomTextField } from '../../widgets/CustomTextField';
import { LookupField } from '../../widgets/LookupField';
import { SelectItem } from '../../widgets/SelectItem';
import ProviderSearch from "../provider/ProviderSearch";
import AssessorSearch from "../assessor/AssessorSearch";
import EmployerSearch from "../employer/EmployerSearch";
import { Row, Col } from 'react-bootstrap';
import ViewUtils from '../../ViewUtils';

const utils = new ViewUtils();

export default function AssessorDocumentSearchForm(props) {
    const [dependency, setDependency] = React.useState(props.dependency);

    React.useEffect(() => {
        setDependency(props.dependency);
    }, [props.dependency]);

    return (
        <EntityForm ref={React.createRef()} viewId="assessor" values={props.data}
            entityLookupController={props.entityLookupController} org="saseta"
            entityLookupId={props.id} useCustomSettings={false} valueChangeHandler={props.valueChangeHandler}>
            {form =>
                <form className={form.classes.container} id="AssessorSearchForm">
                    <div className="row search-form-container">

                        <div className="col form-col">
                            <LookupField
                                id="AssessorID"
                                label="Assessor"
                                className="w-100"
                                required={false}
                                form={form}
                            >
                                <AssessorSearch
                                    showTitle={true}
                                    mode='lookup'
                                    dataUrl="api/sims/assessorletters/AssessorSearch"
                                    onLookupValueChange={(value) => {
                                        form.setLookupSelection("AssessorID", value)
                                    }}
                                    autoFetchData={false}
                                    selection={props.selection}
                                />
                            </LookupField>
                        </div>

                        <div className="col form-col">
                            <LookupField
                                id="ProviderID"
                                label="Provider"
                                className="w-100"
                                required={false}
                                form={form}
                            >
                                <ProviderSearch
                                    showTitle={true}
                                    mode='lookup'
                                    onLookupValueChange={(value) => {
                                        form.setLookupSelection("ProviderID", value)
                                    }}
                                    autoFetchData={false}
                                    selection={props.selection}
                                />
                            </LookupField>
                        </div>

                        <div className="col form-col">
                            <LookupField
                                id="EmployerID"
                                label="Employer"
                                className="w-100"
                                required={false}
                                form={form}
                            >
                                <EmployerSearch
                                    showTitle={true}
                                    mode='lookup'
                                    onLookupValueChange={(value) => {
                                        form.setLookupSelection("EmployerID", value)
                                    }}
                                    autoFetchData={false}
                                    selection={props.selection}
                                />
                            </LookupField>
                        </div>

                        {/*<div className="col form-col">
                            <SelectItem
                                parentId={0}
                                dataUrl="api/indicium/employer/GetLookupList?listId=DocumentType"
                                id="DocumentType"
                                required={true}
                                label="Document Type"
                                className="w-100"
                                form={form}
                            />
                        </div>
                        <div className="col form-col">
                            <SelectItem
                                parentId={0}
                                dataUrl="api/indicium/employer/GetLookupList?listId=PrintType"
                                id="PrintType"
                                hasDependency={true}
                                dependency={dependency}
                                required={true}
                                label="Print Type"
                                className="w-100"
                                form={form}
                            />
                        </div>*/}
                    </div>
                </form>
            }
        </EntityForm >
    );
}